"use strict";
import { __exports as t } from "./index.es459.js";
import { __require as _ } from "./index.es398.js";
import { __require as c } from "./index.es458.js";
var u;
function m() {
  return u ? t : (u = 1, (function(i) {
    Object.defineProperty(i, "__esModule", {
      value: !0
    }), Object.defineProperty(i, "addLocale", {
      enumerable: !0,
      get: function() {
        return n;
      }
    });
    const f = _(), a = c();
    function n(e, r, d, s) {
      if (!r || r === d) return e;
      const o = e.toLowerCase();
      return !s && ((0, a.pathHasPrefix)(o, "/api") || (0, a.pathHasPrefix)(o, "/" + r.toLowerCase())) ? e : (0, f.addPathPrefix)(e, "/" + r);
    }
  })(t), t);
}
export {
  m as __require
};
//# sourceMappingURL=index.es389.js.map
